// Function to make the API call and update the response and code sections
function processJsonAndCallApi(ids) {
  // Split the input by '+' to get multiple orgIds
  const orgIds = ids.split('+').map(id => id.trim());

  // Check if all orgIds are numbers
  if (orgIds.some(id => isNaN(id))) {
      const errorResponse = {
          type: "https://tools.ietf.org/html/rfc9110#section-15.5.1",
          title: "One or more validation errors occurred.",
          status: 400,
          errors: {
              orgId: [
                  `The value ${ids} is not valid.`
              ]
          },
          traceId: "00-XXX-00"
      };
      document.getElementById('response').textContent = JSON.stringify(errorResponse, null, 2);
      return;
  }

  // Simulate reading JSON from a file
  // Simulate reading JSON from a file
  const jsonData = `{
    "content": [
      {
        "id": 165,
        "templateId": 353,
        "orgId": 577,
        "name": "My awesome device",
        "activatedAt": 1234567891234,
        "ownerUserId": 879,
        "hardwareInfo": {
          "version": "1.0.0",
          "fwType": "TMPL0NqfCLjWX",
          "blynkVersion": "1.0.0",
          "boardType": "ESP32s3-NOPSRAM",
          "build": "1",
          "templateId": "TMPL0NqfCLjWX"
        }
      },
      {
        "id": 166,
        "templateId": 353,
        "orgId": 578,
        "name": "My awesome device 1",
        "activatedAt": 2234567891245,
        "ownerUserId": 879,
        "hardwareInfo": {
          "version": "1.0.0",
          "fwType": "TMPL0NqfCLjWX",
          "blynkVersion": "1.0.0",
          "boardType": "ESP32s3-NOPSRAM",
          "build": "1",
          "templateId": "TMPL0NqfCLjWX"
        }
      },
      {
        "id": 179,
        "templateId": 365,
        "orgId": 577,
        "name": "Smart Pad 1",
        "activatedAt": 15234567891388,
        "ownerUserId": 891,
        "hardwareInfo": {
          "version": "2.1.0",
          "fwType": "TMPL0NqfCLjWE",
          "blynkVersion": "2.1.0",
          "boardType": "ESP32s14-NOPSRAM",
          "build": "12",
          "templateId": "TMPL0NqfCLjWE"
        }
      },
      {
        "id": 180,
        "templateId": 366,
        "orgId": 578,
        "name": "Smart Pad 2",
        "activatedAt": 16234567891399,
        "ownerUserId": 892,
        "hardwareInfo": {
          "version": "2.2.0",
          "fwType": "TMPL0NqfCLjWE",
          "blynkVersion": "2.2.0",
          "boardType": "ESP32s15-NOPSRAM",
          "build": "13",
          "templateId": "TMPL0NqfCLjWE"
        }
      },
      {
        "id": 181,
        "templateId": 367,
        "orgId": 579,
        "name": "Smart Pad 3",
        "activatedAt": 17234567891410,
        "ownerUserId": 893,
        "hardwareInfo": {
          "version": "2.3.0",
          "fwType": "TMPL0NqfCLjWF",
          "blynkVersion": "2.3.0",
          "boardType": "ESP32s16-NOPSRAM",
          "build": "14",
          "templateId": "TMPL0NqfCLjWF"
        }
      },
      {
        "id": 182,
        "templateId": 368,
        "orgId": 577,
        "name": "Smart Pad X1",
        "activatedAt": 18234567891421,
        "ownerUserId": 894,
        "hardwareInfo": {
          "version": "2.4.0",
          "fwType": "TMPL0NqfCLjWF",
          "blynkVersion": "2.4.0",
          "boardType": "ESP32s17-NOPSRAM",
          "build": "15",
          "templateId": "TMPL0NqfCLjWF"
        }
      },
      {
        "id": 183,
        "templateId": 369,
        "orgId": 578,
        "name": "Smart Pad A",
        "activatedAt": 19234567891432,
        "ownerUserId": 895,
        "hardwareInfo": {
          "version": "2.5.0",
          "fwType": "TMPL0NqfCLjWG",
          "blynkVersion": "2.5.0",
          "boardType": "ESP32s18-NOPSRAM",
          "build": "16",
          "templateId": "TMPL0NqfCLjWG"
        }
      },
      {
        "id": 184,
        "templateId": 370,
        "orgId": 579,
        "name": "Smart Pad B",
        "activatedAt": 20234567891443,
        "ownerUserId": 896,
        "hardwareInfo": {
          "version": "2.6.0",
          "fwType": "TMPL0NqfCLjWG",
          "blynkVersion": "2.6.0",
          "boardType": "ESP32s19-NOPSRAM",
          "build": "17",
          "templateId": "TMPL0NqfCLjWG"
        }
      },
      {
        "id": 185,
        "templateId": 371,
        "orgId": 577,
        "name": "Smart Pad Alpha",
        "activatedAt": 21234567891454,
        "ownerUserId": 897,
        "hardwareInfo": {
          "version": "2.7.0",
          "fwType": "TMPL0NqfCLjWH",
          "blynkVersion": "2.7.0",
          "boardType": "ESP32s20-NOPSRAM",
          "build": "18",
          "templateId": "TMPL0NqfCLjWH"
        }
      },
      {
        "id": 186,
        "templateId": 372,
        "orgId": 578,
        "name": "Smart Pad 2000",
        "activatedAt": 22234567891465,
        "ownerUserId": 898,
        "hardwareInfo": {
          "version": "2.8.0",
          "fwType": "TMPL0NqfCLjWH",
          "blynkVersion": "2.8.0",
          "boardType": "ESP32s21-NOPSRAM",
          "build": "19",
          "templateId": "TMPL0NqfCLjWH"
        }
      },
      {
        "id": 187,
        "templateId": 373,
        "orgId": 579,
        "name": "Smart Pad Prime",
        "activatedAt": 23234567891476,
        "ownerUserId": 899,
        "hardwareInfo": {
          "version": "2.9.0",
          "fwType": "TMPL0NqfCLjWI",
          "blynkVersion": "2.9.0",
          "boardType": "ESP32s22-NOPSRAM",
          "build": "20",
          "templateId": "TMPL0NqfCLjWI"
        }
      },
      {
        "id": 188,
        "templateId": 374,
        "orgId": 577,
        "name": "Smart Pad Pro",
        "activatedAt": 24234567891487,
        "ownerUserId": 900,
        "hardwareInfo": {
          "version": "3.0.0",
          "fwType": "TMPL0NqfCLjWI",
          "blynkVersion": "3.0.0",
          "boardType": "ESP32s23-NOPSRAM",
          "build": "21",
          "templateId": "TMPL0NqfCLjWI"
        }
      },
      {
        "id": 189,
        "templateId": 375,
        "orgId": 578,
        "name": "Smart Pad Max",
        "activatedAt": 25234567891498,
        "ownerUserId": 901,
        "hardwareInfo": {
          "version": "3.1.0",
          "fwType": "TMPL0NqfCLjWJ",
          "blynkVersion": "3.1.0",
          "boardType": "ESP32s24-NOPSRAM",
          "build": "22",
          "templateId": "TMPL0NqfCLjWJ"
        }
      }
    ],
    "totalElements": 13
}`;
const json = JSON.parse(jsonData);
  const content = json.content; // Correctly accessing content

  let modules = [];
  for (let orgId of orgIds) {
      const filteredModules = content
          .filter(item => item.orgId.toString() === orgId)
          .filter((_, index) => index % 2 === 0);

      modules = modules.concat(filteredModules);
  }

  if (modules.length > 0) {
      const moduleList = modules.map(x => ({
          Id: x.id,
          OrgId: x.orgId,
          Token: x.token,
          Name: x.name,
          IsWet: true
      }));

      // Call the API with the filtered modules
      callApi(moduleList);
  } else {
      const errorResponse = {
          error: {
              code: 404,
              message: "Not Found - Resource Not Found",
              details: `No organization found with orgId ${ids}`
          }
      };
      document.getElementById('response').textContent = JSON.stringify(errorResponse, null, 2);
  }
}

function callApi(modules) {
  document.getElementById('response').textContent = JSON.stringify(modules, null, 2);
}

// Function to update the orgID section
function updateOrgIdSection(orgId) {
  document.getElementById('orgID').textContent = orgId;
}

// Function to update the code section based on the selected language
function updateCodeSection(orgId, language) {
  let code = '';
  switch (language) {
      case 'cpp':
          code = `#include <iostream>
#include <curl/curl.h>

int main() {
  CURL *curl;
  CURLcode res;

  curl_global_init(CURL_GLOBAL_DEFAULT);
  curl = curl_easy_init();
  if(curl) {
      curl_easy_setopt(curl, CURLOPT_URL, "https://u7jhmus484.execute-api.us-east-1.amazonaws.com/Sandbox/SmartModule?orgId=${orgId}");
      curl_easy_setopt(curl, CURLOPT_HTTPHEADER, "Authorization: SXhP97xG_k-HKxvlRynK7Q");
      res = curl_easy_perform(curl);
      if(res != CURLE_OK)
          fprintf(stderr, "curl_easy_perform() failed: %s\\n", curl_easy_strerror(res));
      curl_easy_cleanup(curl);
  }
  curl_global_cleanup();
  return 0;
}
          `;
          break;
      case 'cs':
          code = `using System;
using System.Net.Http;
using System.Threading.Tasks;

class Program {
  static async Task Main() {
      HttpClient client = new HttpClient();
      client.DefaultRequestHeaders.Add("Authorization", "SXhP97xG_k-HKxvlRynK7Q");
      string url = "https://u7jhmus484.execute-api.us-east-1.amazonaws.com/Sandbox/SmartModule?orgId=${orgId}";
      HttpResponseMessage response = await client.GetAsync(url);
      string responseBody = await response.Content.ReadAsStringAsync();
      Console.WriteLine(responseBody);
  }
}
          `;
          break;
      case 'python':
          code = `import requests

url = "https://u7jhmus484.execute-api.us-east-1.amazonaws.com/Sandbox/SmartModule?orgId=${orgId}"
headers = {
  "Authorization": "SXhP97xG_k-HKxvlRynK7Q"
}

response = requests.get(url, headers=headers)
print(response.json())
          `;
          break;
  }
  document.getElementById('code').textContent = code;
}

// Function to handle language button clicks
function handleLanguageButtonClick(event) {
  const orgId = document.getElementById('orgId').value || '-1';
  const language = event.target.getAttribute('data-lang');

  // Update the selected button style
  document.querySelectorAll('.lang-btn').forEach(btn => btn.classList.remove('selected'));
  event.target.classList.add('selected');

  // Update the code section
  updateCodeSection(orgId, language);
}

// Add event listener to the submit button
document.getElementById('submitBtn').addEventListener('click', function () {
  const orgId = document.getElementById('orgId').value || '-1';
  const language = document.querySelector('.lang-btn.selected').getAttribute('data-lang');
  processJsonAndCallApi(orgId);
  updateCodeSection(orgId, language);
});

// Add event listeners to the language buttons
document.querySelectorAll('.lang-btn').forEach(btn => {
  btn.addEventListener('click', handleLanguageButtonClick);
});

// Initialize with the default language (JavaScript)
document.addEventListener('DOMContentLoaded', () => {
  const orgId = document.getElementById('orgId').value || '-1';
  updateCodeSection(orgId, 'js');
});
